import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { type z } from 'zod';

import { useGetCategoryTreesByCountry } from '@/api/gen/category-tree/category-tree.gen';

import { type StudentSchema, type TeacherSchema } from '../schema';

/*
 * 회원가입 폼 작성할 때
 * 선택한 학교 유형과 국가 코드를 기준으로 학년 목록을 가져오는 훅입니다.
 */

export const useSignUpSchoolGrade = () => {
  const { control } =
    useFormContext<z.infer<typeof TeacherSchema | typeof StudentSchema>>();
  const schoolType = useWatch({ control, name: 'schoolType' });
  const countryCode = useWatch({ control, name: 'countryCode' });

  const { data } = useGetCategoryTreesByCountry(countryCode, {
    query: {
      enabled: !!countryCode,
    },
  });

  const grades = useMemo(() => {
    if (!data?.data?.schoolInfoTree) return [];

    const schoolNode = data.data.schoolInfoTree.children.find(
      node => node.name === schoolType,
    );

    if (!schoolNode || schoolNode.children == null) return [];

    return schoolNode.children
      .filter(node => node.type === 'GRADE')
      .map(gradeNode => {
        const gradeNumber = parseInt(gradeNode.categoryGroupId, 10);
        return gradeNumber;
      });
  }, [data?.data?.schoolInfoTree, schoolType]);

  if (grades.includes(0)) return [];

  return grades;
};
